import React from "react";
import { useSearchParams } from "react-router-dom";
import {Pagination, FileList} from "@components";
import { useReference } from "@hooks";

function ReferenceTable({ handleRowClick, selectedId }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const pageIndex = parseInt(searchParams.get("pageIndex") || "1", 10);
  const recordCountPerPage = 5;

  const queryParam = {
    searchCnd: searchParams.get("searchCnd") || "",
    searchWrd: searchParams.get("searchWrd") || "",
    pageIndex,
    recordCountPerPage,
  };
 
  const { data, selectedItems, isAllChecked, handleSelectAll, handleSelectItem, referenceDelete } = useReference(queryParam);

  const handlePageChange = (targetPage) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageIndex", targetPage);
    setSearchParams(newParams);
  };

  
  return (
  <>  
    <div className="section-tit-wrap">
        <h3 className="border-left-primary">
        &nbsp;자료실 목록
        <span className="total-txt">
            {" "} | 총 <span className="red">{data?.totalcount} </span> 건
        </span>
        </h3>
        <div className="btn-box">
            <button type="button" className="btn-delete" onClick={referenceDelete}>삭제</button>
        </div>
    </div>
    <div className="table-container">
        <table className="table-list table-list-file" style={{ width: "100%" }}>
        <colgroup>
            <col style={{ width: "5%" }} />
            <col style={{ width: "5%" }} />
            <col style={{ width: "25%" }} />
            <col style={{ width: "15%" }} />
            <col style={{ width: "15%" }} />
            <col style={{ width: "35%" }} />
        </colgroup>
        <thead>
            <tr>
            <th><input type="checkbox" checked={isAllChecked} onChange={(e) => handleSelectAll(e.target.checked)} /></th>
            <th>No</th>
            <th>제목</th>
            <th>등록일</th>
            <th>게시여부</th>
            <th>첨부파일</th>
            </tr>
        </thead>
        <tbody>
            {data?.resultList && data.resultList.length > 0 ? (
            data.resultList.map((item, idx) => (
                <tr
                    key={item.referenceId}
                    style={{ 
                        backgroundColor:
                        selectedId === item.referenceId ? "#f2f2f2" : "",
                        cursor: "pointer" }}
                        onClick={() => handleRowClick(item)} >
                <td>
                    <input  
                        type="checkbox"
                        checked={selectedItems.includes(item.referenceId)}
                        onChange={(e) => {
                            e.stopPropagation();
                            handleSelectItem(item.referenceId);
                    }} />
                </td>
                <td>{(pageIndex - 1) * recordCountPerPage + idx + 1}</td>
                <td style={{textAlign:"left"}}>{item.title}</td>
                <td>{item.regDtm}</td>
                <td>{item.useYn === 'Y' ? '게시' : '숨김'}</td>
                    <td style={{ textAlign: "left" }}>
                    {item.atchFileId ? (
                        <FileList
                        atchFileId={item.atchFileId}
                        showDelete={false}
                        />
                    ) : (
                        <ul className="existing-files" style={{ minHeight: 28 }}>
                        <li>
                            <div className="file-item-container"></div>
                        </li>
                        </ul>
                    )}
                    </td>
                </tr>
            ))
            ) : (
            <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                조회 결과가 없습니다.
                </td>
            </tr>
            )}
        </tbody>
        </table>
    </div>
        {data?.paginationInfo && data.paginationInfo.totalRecordCount > 0 && (
            <Pagination
                totalPages={Math.ceil(
                data.paginationInfo.totalRecordCount / data.paginationInfo.recordCountPerPage
                )}
                currentPage={pageIndex}
                onPageChange={handlePageChange}
                pageRangeDisplayed={10}
            />
        )}
  </>          
  );
}

export default ReferenceTable;
